import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect, Link, withRouter } from 'react-router-dom';
import { map, uniqBy, debounce, orderBy } from 'lodash';
import qs from 'qs';
import { fetchPackagesAction } from "../../actions/packages";
import './Results.scss';
import { API_ENDPOINT_URL } from "../../constants/default";
import { fetchChannelCategoriesAction } from "../../actions/channelCategories";
import Packages from './Packages';
import CollapsableChannels from './CollapsableChannels';
import ChannelResultItem from './ChannelResultItem';
// import { async } from 'q';

// import Autocomplete from 'react-google-autocomplete';

class PickerResults extends Component {
  constructor(props) {
    super(props);

    this.state = {
      long: '00.000',
      lat: '00.000',
      packages: [],
      bundle: [],
      loading: false,
      bundlesLoading: false,
      backToPicker: false,
      selectedChannels: [],
      orgUUID: null,
      dmaID: null,
      rsn: null,
      searchQuery: '',
      activeView: 'group',
      channels: [],
      Channels: []
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    var updatedState = {};

    if (nextProps.packages !== prevState.packages) {
      updatedState.packages = nextProps.packages.map(p => ({ ...p, type: 'package' }));
    }
    if (nextProps.bundles !== prevState.bundles) {
      updatedState.bundles = (nextProps.bundles || []).map(p => ({ ...p, type: 'bundle' }));
    }
    if (nextProps.loading !== prevState.loading) {
      updatedState.loading = nextProps.loading;
    }
    return updatedState;
  }

  componentDidMount = async () => {
    // const theChannels = this.props.location.state && this.props.location.state.chosenChannels
    // const org_uuid = sessionStorage.getItem('org_uuid');
    // this.props.dispatch(fetchPackagesAction({
    //   "channel_ids": this.props.location.state && this.props.location.state.chosenChannels,
    //   "organization_uuid": org_uuid || '66839209-0c7b-417e-ac38-6f4b93f10620'
    // }))
    let org_uuid = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).orguuid
    console.log(org_uuid, 'org_uuid')
    if (org_uuid) {
      sessionStorage.setItem('org_uuid', org_uuid);
    } else {
      org_uuid = sessionStorage.getItem('org_uuid');
    }
    this.setState({
      orgUUID: org_uuid
    })
    let res = await this.getDMACode();
    if (res.success) {
      let organization_uuid = sessionStorage.getItem('org_uuid')
      this.props.dispatch(fetchChannelCategoriesAction({ rsn: res.rsn, organization_uuid: organization_uuid || undefined, dmaCode: res.dmaID }));
    }
  }

  goBack = () => {
    this.setState({
      backToPicker: true
    })
  }

  queryChannels = () => {
    const theChannels = this.state.selectedChannels
    const org_uuid = sessionStorage.getItem('org_uuid');
    this.props.dispatch(fetchPackagesAction({
      "channel_ids": theChannels,
      "organization_uuid": org_uuid || '66839209-0c7b-417e-ac38-6f4b93f10620'
    }))
  }

  channelSelect = (id) => {
    const val = parseInt(id);
    const currentChannels = this.state.selectedChannels;
    if (currentChannels.includes(val)) {
      const index = currentChannels.indexOf(val);
      currentChannels.splice(index, 1);
      this.setState({
        selectedChannels: currentChannels,
      }, function () {
        this.queryChannels();
      });
    } else {
      currentChannels.push(val);
      this.setState({
        selectedChannels: currentChannels,
      }, function () {
        this.queryChannels();
      });
    }
  }

  handleButtonSubmit(event) {
    event.preventDefault();
  }

  getDMACode = async () => {
    // /dmas/lookup
    // TODO: move to redux
    this.setState({
      loading: true,
    });

    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MjEsImlhdCI6MTUzNzgyMjgwMn0.9Fs54XoZ8F0FCBiWNJPW-9bqoZ_MMnxD4173nMPLft4'
    }
    const latitude = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).lat
    const longitude = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).long
    if (latitude && longitude) {
      var body = {
        longitude,
        latitude
      }

      return axios.post(`${API_ENDPOINT_URL}/dmas/lookup`, body, {
        headers
      }).then((res) => {
        if (res.data.success) {
          this.setState({
            dmaID: res.data.dmaID.toString(),
            rsn: res.data.rsn,
            loading: false,
          })
          return {
            dmaID: res.data.dmaID.toString(),
            rsn: res.data.rsn,
            success: true
          }
        }
        else return {
          success: false
        }
      }).catch((err) => {
        console.log(err)
        this.setState({
          loading: false,
          success: false
        })
      })
    } else {
      return {
        success: false
      }
    }
  }

  updateSearch = (e) => {
    this.setState({
      searchQuery: e.target.value,
    });
  }

  unSelectAll = () => {
    var items = document.getElementsByName('channel');
    for (var i = 0; i < items.length; i++) {
      if (items[i].type == 'checkbox')
        items[i].checked = false;
    }

    this.setState({
      selectedChannels: [],
    });
  }
  onChangeView = (type) => {
    this.setState({ activeView: type })
    if (type === 'list') {
      let channels = this.props.channelCategories.data.reduce((a, c) => [...a, ...c.channels], [])
      this.setState({ channels: orderBy(uniqBy(channels, 'id'), 'name'), Channels: uniqBy(channels, 'id') })
    }
  }
  onSearch = (e) => {
    // let search = e.target.value && e.target.value.toUpperCase()
    e.persist();
    const handleChangeDebounce = debounce((e) => {
      console.log(e.target.value)
      let search = (e.target.value || '').toUpperCase()
      this.setState({
        channels: this.state.Channels.filter(f => {
          return f.name.includes(search)
        })
      })

    }, 500);
    handleChangeDebounce(e);
  }

  render() {
    console.log('[LOADING STATE]', this.state.loading)
    if (this.state.backToPicker === true) {
      return <Redirect
        to='/picker/channel-options'
      />
    }
    const { channelCategories } = this.props;
    const { selectedChannels } = this.state;

    const url_string = window.location.href;
    const url = new URL(url_string);
    const color = url.searchParams.get("color");
    const startOverLink = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).so

    let sidebarHeaderStyles;
    let buttonStyles;
    let sidebarBackgroundStyle;

    sidebarHeaderStyles = {
      background: '#7a7a7a',
    };

    buttonStyles = {
      backgroundColor: '#b0b0b0',
      borderColor: '#a0a0a0',
    }

    sidebarBackgroundStyle = {
      background: '#f7f7f7',
    }

    if (color === 'grey') {
      sidebarHeaderStyles = {
        background: '#7a7a7a',
      };

      buttonStyles = {
        backgroundColor: '#b0b0b0',
        borderColor: '#a0a0a0',
      }

      sidebarBackgroundStyle = {
        background: '#f7f7f7',
      }
    } else if (color === 'red') {
      sidebarHeaderStyles = {
        background: '#f53724',
      };

      buttonStyles = {
        backgroundColor: '#dc3545',
        borderColor: '#bd2130',
      }

      sidebarBackgroundStyle = {
        background: '#f7f7f7',
      }
    }
    return (
      <div>
        <div className="container-fluid mt-5">
          <div className="row">
            <div className="col-lg-3">
              <div className="sidebar" style={sidebarBackgroundStyle}>
                <div className="sidebar-header" style={sidebarHeaderStyles}>
                  <h2 className="d-flex align-items-center justify-content-between"><span>Pick Your Channels</span>{startOverLink ? (<a href={startOverLink} className="btn btn-warning">Start Over</a>) : <Link to="/" className="btn btn-warning">Start Over</Link>}</h2>
                </div>

                <div className="sidebar-body">
                  <p>Select the channels that are important to you</p>

                  <div className="sidebarclear">
                    <button className="btn btn-info w-100 mb-3" onClick={this.unSelectAll} style={buttonStyles}>Clear All</button>
                  </div>
                  <div className="sidebarclear view-container mb-3">
                    <div className={`each-view left ${this.state.activeView === 'group' ? 'active' : ''}`} onClick={() => this.onChangeView('group')}>Group View</div>
                    <div className={`each-view right ${this.state.activeView === 'list' ? 'active' : ''}`} onClick={() => this.onChangeView('list')} >List View</div>
                  </div>
                  {
                    this.state.activeView === 'list' &&
                    <div className="search mb-3">
                      <input placeholder="search for channels" onChange={(e) => this.onSearch(e)} />
                    </div>
                  }

                  {
                    this.state.activeView === 'list' ?
                      this.state.channels.map((channel, index) => (
                        <ChannelResultItem channel={channel} onChannelSelect={(id) => this.channelSelect(id)} key={index} selectedChannels={selectedChannels} />
                      )) :
                      map(channelCategories.data, (item, index) => (
                        <div className="card-group-item" key={index}>
                          <CollapsableChannels
                            item={item}
                            view={this.state.activeView}
                            selectedChannels={selectedChannels}
                            channels={this.state.channels}
                            channelSelect={(id) => this.channelSelect(id)}
                            dmaID={this.state.dmaID}
                            rsn={this.state.rsn}
                            searchQuery={this.state.searchQuery}
                          />
                        </div>
                      ))}
                </div>
              </div>
            </div>

            <div className="col-lg-9">
              <div className="row">
                <div className="col-12">
                  <section className="pricing">
                    <div className="container">
                      {selectedChannels.length > 0 ? (
                        <Packages
                          packages={[...this.state.packages, ...this.state.bundles]}
                          selectedChannels={selectedChannels}
                          loading={this.props.bundlesLoading || false}
                        />
                      ) : null}

                      <p className="disclaimer">Channels and devices may change. Please research packages carefully at their respective websites.</p>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.loading || (this.props.bundlesLoading && selectedChannels.length) ? (
          <div className="loading">
            <h3>Loading Results</h3>
            <div class="spinner">
              <div class="double-bounce1"></div>
              <div class="double-bounce2"></div>
            </div>
          </div>
        ) : null}
      </div>
    )
  }
}

// const mapStateToProps = ({ main, channels }) => ({
//   packages: main.packages.data,
//   bundles: main.bundles.data,
//   bundlesLoading: main.bundles.bundlesLoading,
//   channelCategories: channels.channelCategories.data,
//   loading: channels.channelCategories.loading
// });

// export default connect(mapStateToProps)(PickerResults);

export default withRouter(connect(state => ({
  packages: state.main.packages.data || [],
  bundles: state.main.bundles.data || [],
  channelCategories: state.channels.channelCategories.data || [],
  bundlesLoading: state.main.bundles.bundlesLoading || false,
  loading: state.channels.channelCategories.loading || false,
}))(PickerResults));


// WEBPACK FOOTER //
// ./src/components/Picker/Results.js